export default __webpack_public_path__ + "static/media/success.10ae4b1f.svg";